import { render, staticRenderFns } from "./scale.vue?vue&type=template&id=0204426d&scoped=true"
import script from "./scale.vue?vue&type=script&lang=js"
export * from "./scale.vue?vue&type=script&lang=js"
import style0 from "./scale.vue?vue&type=style&index=0&id=0204426d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0204426d",
  null
  
)

export default component.exports